import React from "react";

/**
 * Displays a progress bar.
 * https://getbootstrap.com/docs/4.0/components/progress/
 * @param {Number} value The current value.
 * @param {Number} max The maximum value.
 * @param props
 * @returns {JSX.Element}
 */
export default function ProgressBar({ value, max, ...props }) {
    const width = Math.round((value / max) * 100);
    return (
        <div className="progress">
            <div className="progress-bar bg-blue" role="progressbar" style={{width: `${width}%`}}
                aria-valuenow={value} aria-valuemin="0" aria-valuemax={max}></div>
        </div>
    );
}
